import bottomTab from "../../resources/tuqqi-talk/en-US/bottomTab.json" 
import chatAddAttachment from "../../resources/tuqqi-talk/en-US/chatAddAttachment.json" 
import chatHeaderMenu from "../../resources/tuqqi-talk/en-US/chatHeaderMenu.json" 
import chatListItem from "../../resources/tuqqi-talk/en-US/chatListItem.json" 
import currentChat from "../../resources/tuqqi-talk/en-US/currentChat.json" 
import drawerPanel from "../../resources/tuqqi-talk/en-US/drawerPanel.json" 
import feed from "../../resources/tuqqi-talk/en-US/feed.json" 

export const enUs = {
	bottomTab, 
	chatAddAttachment, 
	chatHeaderMenu, 
	chatListItem, 
	currentChat, 
	drawerPanel, 
	feed, 
}